import React, { useState, useEffect } from 'react';

// servicess
import authServices from "services/authSvc";
import { Alert,AlertType } from "utils/Alert";

// library
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

// redux
import { useDispatch } from "react-redux";
import { logout, login } from "_redux/actions/authAction";


function EmailVerification(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);

  // const redirectToMenu = () => {
  //   return <Redirect to="/my-application" />;
  // };

  // const onRememberMe = (email, password) => {
  //   if (isRemember) {
  //     authServices.setRemember(email, password);
  //   } else {
  //     authServices.removeRemember();
  //   }
  // };

  useEffect(() => {
    const { id } = props.match.params
    
    authServices.emailVerification(id)
      .then(result => {
        const dataform = JSON.parse(localStorage.getItem("DATA_FORM"));

        if (result.status === 200) {
          const dataResponse = result.data.messages
          Alert.showStatus(
            AlertType.SUCCESS,
            'Congratulation!',
            dataResponse
          )
          setLoading(true);
          dispatch(login(dataform.email, dataform.password))
            .then(() => {
             
              // onRememberMe(dataform.email, dataform.confirmPassword);
              // redirectToMenu();
              history.push("/my-application");
            })
            .catch(() => {
              setLoading(false);
            });
          setLoading(true);
        } else {
          dispatch(logout());
          history.push("/auth/login");
          localStorage.removeItem("DATA_FORM")
          setLoading(false);
        }

      })
      .catch(() => {
        const dataError = "Invalid email verification"
        Alert.showStatus(
          AlertType.ERROR,
          'Error!',
          dataError
        )
        dispatch(logout());
        localStorage.removeItem("DATA_FORM")
        history.push("/auth/login");
      })
  }, [])
  return (
    <div>
      {isLoading && <div className="hidden">.</div>}
    </div>
  )
}

EmailVerification.propTypes = {
  params: PropTypes.string.isRequired,
  // match: PropTypes.shape({
  //   params: PropTypes.shape({
  //     token: PropTypes.string.isRequired
  //   })
  // }),
};

export default EmailVerification
